import { render } from "./DeliveryDatePicker.vue?vue&type=template&id=87836e8e&scoped=true&ts=true"
import script from "./DeliveryDatePicker.vue?vue&type=script&lang=ts"
export * from "./DeliveryDatePicker.vue?vue&type=script&lang=ts"

import "./DeliveryDatePicker.vue?vue&type=style&index=0&id=87836e8e&scoped=true&lang=css"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87836e8e"]])

export default __exports__